<template>
  <div>
    <button
      class="map-modal mt-4 md:mt-12 p-0 size-full relative"
      @click="openFullscreenMap"
    >
      <div
        class="absolute size-full flex pointer-events-none justify-center z-[1] print-hidden"
        :class="seeFullMapButtonPosition === 'bottom' ? 'items-end' : 'items-start'"
      >
        <div
          class="bg-white px-4 pt-1"
          :class="seeFullMapButtonPosition === 'bottom' ? 'rounded-t-lg' : 'rounded-b-lg'"
          data-i18n="seeFullMap"
        >
          <fa
            class="mr-2"
            icon="search"
          />{{ $t('seeFullMap') }}
        </div>
      </div>
      <div class="map overflow-clip max-h-px-350">
        <MapboxPreview
          class="size-full"
          :zoom="zoom"
          :center="mapCenter"
          :markers="points"
          lazy
        />
        <slot name="underPreview" />
      </div>
    </button>
    <b-modal
      :visible="fullscreenMapOpen"
      :hide-footer="true"
      :hide-header="true"
      size="xl"
      body-class="!p-1"
      content-class="rounded-none !w-full"
      modal-class="md:pt-3"
      centered
      @hide="closeFullscreenMap"
    >
      <div class="map-modal marked-map-modal flex flex-col">
        <LazyModalCloseButton
          align="outside"
          @click="closeFullscreenMap"
        />
        <div class="grow relative map-modal-map overflow-clip">
          <LazyMapbox
            ref="mapbox"
            class="absolute"
            :center="mapCenter"
            :zoom="zoom"
            size-to-parent-bounds
          >
            <LazyMapboxMarker
              v-for="(point, idx) in points"
              :key="idx"
              :coordinates="point"
            />
            <LazyMapboxNavigationControl />
          </LazyMapbox>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script setup>
const props = defineProps({
  points: {
    type: Array,
    required: true,
  },

  center: {
    type: Array,
    default: null,
  },

  seeFullMapButtonPosition: {
    type: String,
    default: 'bottom',
  },

  zoom: {
    type: Number,
    default: 14,
  },
})

const fullscreenMapOpen = ref(false)

const mapCenter = computed(() => props.center ?? props.points[0])

const openFullscreenMap = () => {
  fullscreenMapOpen.value = true
}

const closeFullscreenMap = () => {
  fullscreenMapOpen.value = false
}
</script>

<style lang="scss">
.map-modal {
  .map {
    height: 386px;
    min-width: unset;
  }

  &.marked-map-modal {
    min-height: 85vh;
  }

  .map-modal-map {
    min-height: 500px;
  }
}
</style>
